import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js");
